import {BOM} from './BOM';

const CACHE = {
    lang: null,
    urlParams: null,
    env: null,
    nest: null,
    urlParamsString: null,
    deviceType: -1, //1 ios
    iphoneX: -1, //1 iphonex
};
function isStrictlyNotParsableToInt(str) {
    // 正则表达式检查字符串是否为有效的数字（整数或小数）
    const regex = /^-?\d+(\.\d+)?$/;
    // 如果字符串匹配正则表达式，返回 false，否则返回 true
    return !regex.test(str);
}
//
function format(param, replace = true) {
    if (typeof param == 'undefined') {
        return '';
    }
    if (typeof param != 'object') {
        throw new Error('data sended to the server must be \'object\'');
    }
    let s = [];
    for (let j in param) {
        s.push(encodeURIComponent(j) + '=' + encodeURIComponent(param[j]));
    }
    if (replace) {
        return s.join('&').replace(/%20/g, '+');
    } else {
        return s.join('&');
    }
}

const _jsonFields = ['extra_data', 'list', 'dm_info', 'extra', 'calendar', 'track_extra'];

function deFormat(param, num_type = 0, jsonFields = _jsonFields) {
    let p = {};
    let temp = param.split('&');
    for (let i = 0, l = temp.length; i < l; i++) {
        let t = temp[i].split('=');
        if (jsonFields.indexOf(t[0]) != -1) {
            p[t[0]] = JSON.parse(decodeURIComponent(t[1]));
        } else {
            //10 作为临界定，为大整数，应该传str
            if (isStrictlyNotParsableToInt(t[1]) || t[1].length > 15) {
                p[t[0]] = decodeURIComponent(t[1]);
            } else {
                if (num_type) {
                    p[t[0]] = t[1];
                } else {
                    const num = parseFloat(t[1]);
                    p[t[0]] = num;
                }
            }
        }
    }
    return p;
}

//控制字符长度
function countChars(s, len, flag) {
    let str = new String(s);
    let strLen = str.replace(/[\uFE30-\uFFA0\u2E80-\u9FFF\u3000\uac00-\ud7ff‘“”’]/g, '**').length,
        newStr = [],
        totalCount = 0;
    if (strLen <= len) {
        return str;
    } else {
        for (let i = 0; i < strLen; i++) {
            let nowValue = str.charAt(i);
            // eslint-disable-next-line no-control-regex
            if (/[^\x00-\xff]/.test(nowValue)) {
                totalCount += 2;
            } else {
                totalCount += 1;
            }
            newStr.push(nowValue);
            if (totalCount >= len) {
                break;
            }
        }
        if (flag) {
            return newStr.join('');
        } else {
            return newStr.join('') + '...';
        }
    }
}

//取得网页query 参数
function getUrlStrs(href) {
    let queryString = '';
    if (href) {
        const urls = href.split('?');
        queryString = urls[1] ? '?' + urls[1] : '';
    } else {
        if (CACHE.urlParams) return CACHE.urlParams;
        const urls = BOM.window.location.href.split('?');
        queryString = urls[1] ? '?' + urls[1] : '';
    }
    const data = {}, reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g');
    queryString.replace(reg, function ($0, $1, $2, $3) {
        data[$1] = $3.split('#')[0];
    });
    if (!href) {
        CACHE.urlParams = data;
    }
    return data;
}

function getUniversalParameters() {
    if (CACHE.urlParamsString) return CACHE.urlParamsString;
    let querystring = /.+(\?.+)/.exec(window.location.href);
    if (querystring) {
        querystring = querystring[1];
    } else {
        querystring = '';
    }
    CACHE.urlParamsString = querystring;
    return querystring;
}

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + '=');
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            let c_end = document.cookie.indexOf(';', c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
}

function setCookie(name, value, days, path) {
    let Days = days || 30;
    let exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    if (!path) {
        document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
    } else {
        document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=' + path;
    }
}

//dom 元素位置
function getPosition(node) {
    let posx = 0,
        posy = 0;
    while (node.offsetParent) {
        posy = posy + node.offsetTop;
        posx = posx + node.offsetLeft;
        node = node.offsetParent;
    }
    return {
        x: posx,
        y: posy
    };
}

function isIos() {
    if (CACHE.deviceType != -1) {
        return CACHE.deviceType;
    }
    if (!navigator) {
        return false;
    }
    if (!navigator.userAgent) {
        return false;
    }
    const is = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    CACHE.deviceType = is;
    return is;
}

//1 =>01
function toTwoDigit(num) {
    return num < 10 ? '0' + num : num + '';
}

//日期格式化  yyyy年MM月dd日 => 2022年04月14日
function formatDate(time, formation) {
    let date = new Date(time);
    let _temp_year = date.getFullYear();
    let _temp_month = date.getMonth() + 1;
    let _temp_date = date.getDate();
    let _temp_hour = date.getHours();
    let _temp_minute = date.getMinutes();
    let _temp_second = date.getSeconds();

    function _get_date_part(part) {
        switch (part) {
        case 'yyyy':
            return _temp_year;
        case 'yy':
            return _temp_year.toString().slice(-2);
        case 'MM':
            return toTwoDigit(_temp_month);
        case 'M':
            return _temp_month;
        case 'dd':
            return toTwoDigit(_temp_date);
        case 'd':
            return _temp_date;
        case 'HH':
            return toTwoDigit(_temp_hour);
        case 'H':
            return _temp_hour;
        case 'hh':
            return toTwoDigit(_temp_hour > 12 ? _temp_hour - 12 : _temp_hour);
        case 'h':
            return _temp_hour > 12 ? _temp_hour - 12 : _temp_hour;
        case 'mm':
            return toTwoDigit(_temp_minute);
        case 'm':
            return _temp_minute;
        case 'ss':
            return toTwoDigit(_temp_second);
        case 's':
            return _temp_second;
        default:
            return part;
        }
    }

    return formation.replace(/y+|m+|d+|h+|s+|H+|M+/g, _get_date_part);
}

//取得静态分页数据
function getStaticData(store, page, page_size) {
    let length = store.length;
    let _page_size = page_size || 10;
    let start = page * _page_size,
        end = (page + 1) * _page_size;
    end = Math.min(end, length);
    start = Math.min(start, length);
    return {
        data: store.slice(start, end),
        has_more: end != length
    };
}

//翻译 "hell%s wo%sld 1%d3" ["o","r",2]  => hello world 123
function translate(str, replace_ary) {
    let reg = str.match(/%s|%d/g);
    if (reg) {
        for (let i = 0; i < reg.length; i++) {
            str = str.replace(reg[i], replace_ary[i]);
        }
    }
    return str;
}

function getDeviceSniffSize() {
    const ratio = isIos() ? Math.min(window.devicePixelRatio, 3) : 1 || 1;
    return {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
    };
}

//是否iphonex 以及以上
function isIphoneX() {
    if (CACHE.iphoneX != -1) {
        return CACHE.iphoneX;
    }
    let ratio = window.devicePixelRatio || 1;
    let screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
    };
    //iphone11 2x
    const is =
        /iphone/gi.test(navigator.userAgent) && (screen.height >= 2436 || screen.height === 1792);
    CACHE.iphoneX = is;
    return is;
}

//取得app版本，用于版本比较
function getAppVersion(v) {
    const _v = v || '.';
    const _varray = _v.split('.');
    const l = _varray.length;
    if (l <= 1 || l > 4) {
        return 1000000;
    }
    if (l === 2) {
        _varray.push('0', '0');
    } else if (l === 3) {
        _varray.push('0');
    }
    return +_varray[0] * 1000000 + +_varray[1] * 10000 + +_varray[2] * 100 + +_varray[3];
}

//当前环境:测试 | 线上
function getEnv() {
    if (CACHE.env) return CACHE.env;
    let _htmlNode = document.getElementsByTagName('html')[0];
    let _env = _htmlNode.getAttribute('env');
    if (_env) {
        CACHE.env = _env;
    }
    return CACHE.env || 'cdn';
}

//取得当前运行环境
//browser,simulator
function getNest() {
    if (CACHE.nest) return CACHE.nest;
    let _htmlNode = document.getElementsByTagName('html')[0];
    let _nest = _htmlNode.getAttribute('nest');
    if (_nest) {
        CACHE.nest = _nest;
    }
    return CACHE.nest || 'browser';
}

//
function getLang() {
    if (CACHE.lang) return CACHE.lang;
    let _htmlNode = document.getElementsByTagName('html')[0];
    let _lang = _htmlNode.getAttribute('lang');
    if (_lang) {
        CACHE.lang = _lang;
    }
    return CACHE.lang || 'ja';
}


//版本号判定 v >= targetV
function isVersionMoreThanOrEqualTo(v, targetV) {
    const currentVersion = getAppVersion(v);
    const targetVersion = getAppVersion(targetV);
    if (currentVersion >= targetVersion) {
        return true;
    }
    return false;
}

//10000 ===> 10k
function kformat(_num, length = 2) {
    let num = _num || 0;
    if (num.length) {
        num = parseInt(num);
    }
    if (num >= 1000000) {
        return (num / 1000000).toFixed(length) + 'm';
    } else {
        if (num > 1000) {
            if (num % 1000 < 10) {
                return (num / 1000).toFixed(0) + 'k';
            } else {
                return (num / 1000).toFixed(length) + 'k';
            }
        }
    }
    return num;
}


//xss && 保留空格与换行
function formatInput(str) {
    return encodeSpecialHtmlChar(str)
        .replace(/\u0020/g, '&nbsp;')
        .replace(/\n/g, '<br />');
}

//
function loadMedia(ele, mediaType = 0) {
    let w = mediaType === 0 ? ele.naturalWidth : ele.videoWidth,
        h = mediaType === 0 ? ele.naturalHeight : ele.videoHeight,
        p_w = ele.parentNode.offsetWidth,
        p_h = ele.parentNode.offsetHeight,
        percent = w / h,
        p_percent = p_w / p_h;
    if (percent < p_percent) {
        let w = p_h * percent;
        ele.style.height = p_h ? p_h + 'px' : '100%';
        ele.style.width = w ? w + 'px' : '100%';
    } else {
        let h = p_w / percent;
        ele.style.height = h ? h + 'px' : '100%';
        ele.style.width = p_w ? p_w + 'px' : '100%';
    }
}

const s = 60;
const hour_s = 3600;
const day_s = hour_s * 24;

//秒数 对应的日，时，分，秒
function getGapTime(seconds) {
    if (seconds <= 0) {
        return {
            day: 0,
            hour: 0,
            min: 0,
            sec: 0
        };
    }
    const day = Math.floor(seconds / day_s);
    const hour = Math.floor((seconds % day_s) / hour_s);
    const min = Math.floor((seconds - day_s * day - hour_s * hour) / s);
    const sec = seconds - day_s * day - hour_s * hour - min * s;
    return {
        day,
        hour,
        min,
        sec
    };
}


function createRequestId() {
    return new Date().getTime().toString() + Math.ceil(Math.random() * 1000).toString();
}


//取得rem font-size
function getFontSize() {
    const htmlStyle = document.getElementsByTagName('html')[0].getAttribute('style');
    if (htmlStyle) {
        const matchArray = htmlStyle.match(/\d+(\.\d+)?/g);
        if (matchArray && !isNaN(matchArray[0])) {
            return matchArray[0];
        }
    }
    return 0;
}

function getDpr() {
    const dpr = document.getElementsByTagName('html')[0].getAttribute('data-dpr');
    return parseInt(dpr);
}

function insertBr(str, length) {
    const size = Math.ceil(str.length / length);
    const temp = Array.from(new Array(size).keys());
    temp.shift();
    let pool = temp.map(v => {
        return v * length - 1;
    });
    let final = [];
    for (let i = 0; i < str.length; i++) {
        final.push(str[i]);
        if (pool.indexOf(i) != -1) {
            final.push('<br>');
        }
    }
    return final.join('');
}

function setTitle(title) {
    BOM.document.getElementsByTagName('title')[0].innerText = title;
}

const regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/gi;

function getTextLength(str) {
    return str.replace(regStr, '*').length;
}

//取得 固定rem尺寸的实际px大小
function getSize(num) {
    const fontSize = getFontSize();
    return (num * fontSize) / 100;
}

//纵向滚动浏览器滚动条，并执行回调
function windowScrollTo(dis, cb) {
    if(windowScrollTo.dis===dis){
        return;
    }
    BOM.window.scrollTo({
        top: dis,
        left: 0,
        behavior: 'smooth'
    });
    if (cb) {
        //兼容ios滑动之后焦点丢失的问题
        let t;
        const running = e => {
            t && clearTimeout(t);
            t = setTimeout(() => {
                cb();
                BOM.window.removeEventListener('scroll', running);
            }, 100);
        };
        BOM.window.addEventListener('scroll', running, false);
    }
    windowScrollTo.dis=dis;
}

//处理xss
function encodeSpecialHtmlChar(str) {
    if (str) {
        let codingchar = [
            '&',
            '<',
            '>',
            '"',
            '\'',
            'onclick',
            'onfocus',
            'onmouseover',
            'onmouseout',
            'script',
            'iframe'
        ];
        let sepchar = ['&amp;', '&lt;', '&gt;', '&quot;', '&apos;', '', '', '', '', '', ''];
        let len = sepchar.length;

        for (let i = 0; i < len; i++) {
            str = str.replace(new RegExp(codingchar[i], 'ig'), sepchar[i]);
        }
        return str;
    } else {
        return '';
    }
}

//取得字符串长度（一个日文两个字符）
function getCharSize(str) {
    return str.replace(/[\uFE30-\uFFA0\u2E80-\u9FFF\u3000\uac00-\ud7ff‘“”’]/g, '**').length;
}

/*
*校验日本身份证号：12位数字
*用于输入实时验证
 */
function filterIdCardNumber(val) {
    return val.replace(/[^\d]/g, '').substr(0, 12);
}

/*
* 取得url param参数
* 例
* https://u.pokekara.com/mv/234555 ===> 234555
* */
function getUrlParams(url) {
    let pathname = window.location.pathname;
    if (url) {
        const urlStr = url.split('?')[0];
        const index = urlStr.indexOf('/');
        pathname = urlStr.slice(index, urlStr.length);
    }
    const index = pathname.lastIndexOf('/');
    if (index != -1) {
        return pathname.slice(index + 1, pathname.length);
    } else {
        return '';
    }
}

//是否移动端
function isMobile(agent) {
    const _agent = agent || BOM.window.navigator.userAgent;
    return /(iPhone|iPad|iPod|iOS|android|BlackBerry|hp-tablet|Symbian|Windows Phone)/i.test(
        _agent
    );
}

//是否需要border 1像素处理(安卓小屏幕bug)
function needBorderFix() {
    const size = getFontSize();
    return size < 50;
}

//整除
function mod(num, unit = 10) {
    return Math.floor(num / unit);
}

//计算年龄
function calculatAge(y, m, d) {
    const now = new Date();
    const _y = now.getFullYear() - y;
    const _m = now.getMonth() + 1 - m;
    const _day = now.getDate() - d;
    if (_m > 0) {
        return _y;
    } else if (_m === 0) {
        if (_day >= 0) {
            return _y;
        } else {
            return _y - 1;
        }
    } else {
        return _y - 1;
    }
}

//设置css变量
function setStyleVariable(config) {
    const style = config.style;
    style && Object.keys(style).forEach(key => {
        BOM.document.documentElement.style.setProperty(key, style[key]);
    });
}

function isProductionEnv() {
    const env = getEnv();
    return env === 'cdn' || env === 'online';
}

function isSimulatorEnv() {
    return getNest() === 'simulator';
}

function getCascadeValueFromObject(data, keys) {
    try {
        let result = data;
        for (const key of keys) {
            result = result[key];
        }
        return result;
    } catch (error) {
        return null;
    }
}
function setCascadeValueFromObject(data, keys, value) {
    try {
        let current = data;
        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];
            if (!current[key] || typeof current[key] !== 'object') {
                current[key] = {};  // 创建中间缺失的对象
            }
            current = current[key];
        }
        current[keys[keys.length - 1]] = value;
        return true;
    } catch (error) {
        // 处理异常，例如输出错误日志
        return false;
    }
}
function isFacebookApp() {
    const ua = BOM.window.navigator.userAgent || BOM.window.navigator.vendor || BOM.window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

function isWebPageFileOpen(){
    return BOM.window.location.protocol === "file:"
}

function isLocalDev() {
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    const hostName = BOM.window.location.hostname;
    if (hostName.indexOf('localhost') != -1 || ipPattern.test(BOM.window.location.hostname)) {
        return true;
    }
}

export {
    format,
    countChars,
    getUrlStrs,
    getUniversalParameters,
    getCookie,
    setCookie,
    getPosition,
    isIos,
    toTwoDigit,
    formatDate,
    getStaticData,
    translate,
    getDeviceSniffSize,
    isIphoneX,
    getAppVersion,
    getEnv,
    getLang,
    isVersionMoreThanOrEqualTo,
    kformat,
    formatInput,
    loadMedia,
    getGapTime,
    createRequestId,
    getFontSize,
    getDpr,
    insertBr,
    setTitle,
    getTextLength,
    getSize,
    windowScrollTo,
    deFormat,
    encodeSpecialHtmlChar,
    getCharSize,
    filterIdCardNumber,
    getUrlParams,
    isMobile,
    needBorderFix,
    mod,
    calculatAge,
    setStyleVariable,
    isProductionEnv,
    isSimulatorEnv,
    getCascadeValueFromObject,
    setCascadeValueFromObject,
    isFacebookApp,
    isStrictlyNotParsableToInt,
    isWebPageFileOpen,
    isLocalDev
};
